


























































































/* Created- 11 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaFullDialog from "@/Ui-Components/Common/Container/ParticaFullDialog.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaArticlePreview from "@/Ui-Components/Article/Preview/ParticaArticlePreview.vue";
import ParticaArticleWritten from "@/Ui-Components/Article/Edit/ParticaArticleWritten.vue";
import ParticaConfirmDialog from "@/Ui-Components/Common/ConfirmDialog/ParticaConfirmDialog.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { ParticaItem, ParticaDropEvent, eParticaDragType } from "../../Models/ParticaItem";
import { eParticaAction, ParticaEvent, getActionName } from "../../Models/ParticaEvent";
import { ParticaConfirmConfig } from "../../Models/Components.model";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../Models/Buttons";
import ParticaBaseView from "../Base/ParticaBaseView.vue";
import { IWrittenArticleService } from "../../BusinessServices/writtenarticles";
import { IArticle, IWrittenArticle, Article } from "../../Models/ArticleModels/article";
import ManageArticles from "@/Ui-Components/Article/ManageArticles.vue";
import WrittenManager from "./WrittenManager.vue";
import ParticaAccountBase from "../Base/ParticaAccountBase.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ISyndicationArticleService } from "../../BusinessServices/syndication";
import { SyndicationArticleDto } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "WrittenArticles",
		components: {
			ParticaRowContainer,
			ParticaFullDialog,
			ParticaArticleWritten,
			ParticaArticlePreview,
			ParticaConfirmDialog,
			ButtonList,
			ParticaCard,
			ManageArticles,
			WrittenManager,
			ParticaView
		}
	})
export default class WrittenArticles extends ParticaAccountBase {
	@Prop() private id: number;
	private writtenArticleService: IWrittenArticleService;
	private syndicationArticleService: ISyndicationArticleService;
	private articles: ParticaItem[] = [];
	private showmanager: boolean = false;
	private publicationToAdd: number = 0;

	private buttons: ButtonConfig[] = [
		{
			label: "Folder Manager",
			action: eParticaAction.WRITTEN_CATEGORY_MANAGER,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig
	];

	private previewarticle: IArticle = new Article() as IArticle;
	private showpreview: boolean = false;
	private previewbuttons: ButtonConfig[] = [
	];

	private editarticle: IWrittenArticle = new Article() as IWrittenArticle;
	private showedit: boolean = false;
	private editbuttons: ButtonConfig[] = [
		{
			label: "Save Article",
			action: eParticaAction.ARTICLE_SAVE,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Move to Proof",
			action: eParticaAction.ARTICLE_MOVE_PROOF,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	@Watch("showmanager")
	private async reloadsections() {
		if (this.showmanager === false) {
			await this.init();
		}
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.PROPERTY_CHANGED: {
					break;
				}
				case eParticaAction.WRITTEN_CATEGORY_MANAGER: {
					this.showmanager = true;
					break;
				}
				case eParticaAction.ARTICLE_MOVE_PROOF: {
					const moveDto: SyndicationArticleDto = new SyndicationArticleDto();
					moveDto.articleId = this.editarticle.articleId;
					moveDto.issueId = this.editarticle.issueId;
					const warnings: string[] = await this.syndicationArticleService.moveArticleToProof(moveDto);
					if (warnings.length > 0) {
						let msg: string = "";
						warnings.forEach(warning => {
							msg += warning + "\n";
						});
						this.ShowSnackbar(msg);
					}
					break;
				}
				case eParticaAction.ARTICLE_SAVE: {
					this.editarticle = await this.writtenArticleService.saveArticle(this.editarticle, this.publicationToAdd);
					await this.init();
					break;
				}
				case eParticaAction.ADD_WRITTEN_ARTICLE: {
					this.editarticle = new Article() as IWrittenArticle;
					this.publicationToAdd = event.item.id;
					this.showedit = true;
					break;
				}
				case eParticaAction.ARTICLE_EDIT:
				case eParticaAction.RIGHT_MOUSE_CLICK: {
					this.editarticle = await this.writtenArticleService.getArticle(event.item.id as string);
					this.showedit = true;
					break;
				}
				case eParticaAction.ARTICLE_DELETE_REQUEST: {
					this.dialog.title = "Confirm deletion of article.";
					this.dialog.message = `You have requested that article '${event.item.name}' be deleted.`;
					this.dialog.action = eParticaAction.ARTICLE_DELETE;
					this.dialog.show = true;
					break;
				}
				case eParticaAction.ARTICLE_DELETE: {
					this.dialog.show = false;
					this.ShowSnackbar("do delete");
					break;
				}
				case eParticaAction.ARTICLE_PREVIEW: {
					this.previewarticle = (await this.writtenArticleService.getArticle(event.item.id as string)) as IArticle;
					this.showpreview = true;
					break;
				}
				case eParticaAction.DRAG_MOVE_REQUEST: {
					const movedata: ParticaDropEvent = event.item as ParticaDropEvent;
					switch (movedata.dragtype) {
						case eParticaDragType.one: {
							this.dialog.title = "Confirm moving article.";
							this.dialog.message = `Move article '${movedata.source.name}' to category '${movedata.destination.name}'?`;
							this.dialog.action = eParticaAction.DRAG_MOVE;
							this.dialog.item = movedata;
							this.dialog.show = true;
							break;
						}
						case eParticaDragType.many: {
							this.dialog.title = "Confirm moving articles.";
							this.dialog.message = `Move all articles from category '${movedata.source.name}' to category '${movedata.destination.name}'?`;
							this.dialog.action = eParticaAction.DRAG_MOVE;
							this.dialog.item = movedata;
							this.dialog.show = true;
							break;
						}
						case eParticaDragType.all: {
							// check issue is not dropped on itself.
							// confirm you want to move all articles in issue to new issue.
							// if different pub then sections will be created if they do not exist.
							this.ShowSnackbar(`not implemented`);
							break;
						}
					}
					break;
				}
				case eParticaAction.DRAG_MOVE: {
					const movedata: ParticaDropEvent = event.item as ParticaDropEvent;
					switch (movedata.dragtype) {
						case eParticaDragType.one: {
							this.dialog.show = false;
							await this.writtenArticleService.moveArticle(movedata.source.id, parseInt(movedata.destination.id, 0));
							await this.init();
							break;
						}
						case eParticaDragType.many: {
							this.dialog.show = false;
							const section: ParticaItem | undefined = this.articles.find(a => a.id === movedata.source.id);
							if (section !== undefined) {
								const articleIds: string[] = section.items.map(i => i.id);
								await this.writtenArticleService.moveArticles(articleIds, parseInt(movedata.destination.id, 0));
								/*for (const item of section.items) {
									await this.writtenArticleService.moveArticle(item.id, parseInt(movedata.destination.id, 0));
								}*/
							}
							await this.init();
							break;
						}
						case eParticaDragType.all: {
							// this.ShowSnackbar(`confirm move many ${movedata.source.name} to ${movedata.destination.name}`)
							break;
						}
					}
					break;
				}

				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Written Articles";
		this.writtenArticleService = this.particaServices.getWrittenArticleService();
		this.syndicationArticleService = this.particaServices.getSyndicationArticleService();
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getAccountNav(this.id);
			this.articles = await this.writtenArticleService.getArticlesByPublication(this.id);
			if (this.articles.length === 0) {
				this.ShowSnackbar("You do not have any article folders. Use Folder Manage to create one before adding an article. Click help for more information.");
			}

		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}


}
